import styled from 'styled-components';

export const FormContentWrapper = styled.div`
  .ant-form-item,
  & > div {
    margin-bottom: 0;
  }
`;
